
import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { cleanInternalLinkUrl, wrapTrademarkSuperscript } from '../../utils/cob-utils';
import './MobileWalletAdModule.css';
import SessionStorage from '../../utils/SessionStorage';
import { IAppApprovedData } from '../ConfirmationPageHero/ConfirmationPageHero';
import { Button } from '../../importCL';

interface IMobileWalletAdModuleProps extends MappedComponentProperties {
    mobileWalletTitle?: string;
    mobileWalletImage?: string;
    mobileWalletAltText?: string;
    mobileSubText?: string;
    mobileCTAText?: string;
    mobileCTALink?: string;
}

export const MobileWalletAdModuleEditConfig = {
    emptyLabel: 'Mobile Wallet Ad Module',
    isEmpty: (props: PropsWithChildren<IMobileWalletAdModuleProps>) => {
        return !props || !props.mobileWalletTitle;
    },
};

const MobileWalletAdModule = (props: PropsWithChildren<IMobileWalletAdModuleProps>): JSX.Element => {
    const [approvedData, setApprovedData] = useState<IAppApprovedData>({});

    const populateDynamicTitle = (title: string) => {
        if (approvedData !== null && approvedData.CardOffer) {
            const superScriptCardOffer = wrapTrademarkSuperscript(approvedData.CardOffer);
            const formattedTitle = title.replace(/\{CardOffer\}/g, superScriptCardOffer);
            return formattedTitle;
        }
        return title;
    };

    useEffect(() => {
        const getApprovedApplicationData = async () => {
            const approvedDataSs = await SessionStorage.tryGetCipher('app-approved-data', null);
            setApprovedData(approvedDataSs);
        };
        getApprovedApplicationData();
    }, []);

    const setInstantProvisioningEsignFlagAndRedirect = () => {
        // Special flag for indicating special case esign for instant provisioning which must show regardless of other previous full/limited-esign
        SessionStorage.set('isEsignInstantProvisioning', 'true');
        window.location.assign(cleanInternalLinkUrl(props.mobileCTALink + '.html' + window.location.search));
    };

    return (
        <div className='MobileWalletAdModule' id='mobile-wallet-ad-module'>
            {props.mobileWalletTitle &&
                <h3 className='MobileWalletAdModule__title'>
                    {transformHTMLParserLinks(populateDynamicTitle(props.mobileWalletTitle))}
                </h3>
            }
            <div className='MobileWalletAdModule__content'>
                {(props.mobileWalletImage || props.mobileWalletAltText) &&
                    <div className='MobileWalletAdModule__imageContainer'>
                        <img className='MobileWalletAdModule__imageContent' loading='lazy' src={props.mobileWalletImage} alt={props.mobileWalletAltText} />
                    </div>
                }
                <div className='MobileWalletAdModule__nonImageContent'>
                    {props.mobileSubText &&
                        <p className='MobileWalletAdModule__subtext'>
                            {transformHTMLParserLinks(props.mobileSubText)}
                        </p>
                    }
                    {props.mobileCTAText && props.mobileCTALink &&
                        <div className='MobileWalletAdModule__CTA'>
                            <Button disableOnClick size='medium' onClick={setInstantProvisioningEsignFlagAndRedirect}>
                                {transformHTMLParserLinks(wrapTrademarkSuperscript(props.mobileCTAText)) as unknown as ReactElement}
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default MobileWalletAdModule;
